/** Product navigation labels; shared renderers and other products keep their contracts. */
export const memberAdminNavigationDe = {
  "MemberAdmin.disruptions": "Störungen",
  "AdminStructure.operations": "Betrieb",
  "AdminStructure.settings": "Einstellungen",
  "MemberAdmin.generalDescription": "Designs und Schriftarten der Plattform",
  "MemberAdmin.platformServices": "Plattformdienste",
  "MemberAdmin.registration": "Selbstregistrierung",
  "MemberAdmin.registrationDescription": "Registrierung neuer Mandanten und Vorlagemandant",
  "MemberAdmin.tenantDirectDebits": "Lastschriftläufe",
  "MemberAdmin.capabilities": "Funktionen",
  "MemberAdmin.users": "Admins",
  "MemberAdmin.tenantDirectDebitsDescription": "SEPA-Läufe der Studios einsehen und stornieren",
  "MemberAdmin.uscDescription": "Zentraler Anwendungszugang, Webhooks und Studiofreischaltung",
  "MemberAdmin.emailDescription": "E-Mail-Konten und Versandkonfiguration der Plattform",
  "MemberAdmin.ownIntegrations": "Schnittstellen",
  "MemberAdmin.banking": "Bankzugriff",
  "MemberAdmin.bankingDescription": "Zugelassene Bankzugangsverfahren und Anmeldeversuche",
  "MemberAdmin.bankDirectory": "Bankverzeichnis",
  "MemberAdmin.ownFormats": "Anzeigeformate",
  "MemberAdmin.ownFormatsDescription": "Datums-, Zahlen- und Zeitformate für das angemeldete Konto",
  "IntegrationCategories.payments": "Zahlungen",
  "IntegrationCategories.partners": "Partner und Check-in",
  "IntegrationCategories.communication": "Kommunikation",
  "IntegrationCategories.api": "Daten und API",
  "IntegrationCategories.paymentAccess": "Zahlungsschnittstellen benötigen studioübergreifenden Zugriff. Bitte die Studio-Berechtigung des Kontos prüfen.",
  "SettingsCards.settings.integrations": "Zahlungsanbieter, Partner, Kommunikation und API-Anbindungen",
} as const;

export const memberAdminNavigationEn = {
  "MemberAdmin.disruptions": "Disruptions",
  "AdminStructure.operations": "Operations",
  "AdminStructure.settings": "Settings",
  "MemberAdmin.generalDescription": "Platform themes and fonts",
  "MemberAdmin.platformServices": "Platform services",
  "MemberAdmin.registration": "Self-registration",
  "MemberAdmin.registrationDescription": "New tenant registration and template tenant",
  "MemberAdmin.tenantDirectDebits": "Direct debit runs",
  "MemberAdmin.capabilities": "Features",
  "MemberAdmin.users": "Admins",
  "MemberAdmin.tenantDirectDebitsDescription": "View and cancel studio SEPA runs",
  "MemberAdmin.uscDescription": "Central application access, webhooks and studio onboarding",
  "MemberAdmin.emailDescription": "Platform email accounts and delivery configuration",
  "MemberAdmin.ownIntegrations": "Integrations",
  "MemberAdmin.banking": "Bank access",
  "MemberAdmin.bankingDescription": "Permitted bank access methods and sign-in attempts",
  "MemberAdmin.bankDirectory": "Bank directory",
  "MemberAdmin.ownFormats": "Display formats",
  "MemberAdmin.ownFormatsDescription": "Date, number and time formats for the signed-in account",
  "IntegrationCategories.payments": "Payments",
  "IntegrationCategories.partners": "Partners and check-in",
  "IntegrationCategories.communication": "Communication",
  "IntegrationCategories.api": "Data and API",
  "IntegrationCategories.paymentAccess": "Payment interfaces require access to all studios. Please check the account's studio permissions.",
  "SettingsCards.settings.integrations": "Payment providers, partners, communication and API connections",
} as const;
